import { VxeCheckboxGroup } from 'vxe-pc-ui';
import defPropMixin from './defPropMixin';
export default {
  name: 'XCheckboxGroup',
  components: {
    VxeCheckboxGroup
  },
  mixins: [defPropMixin],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    optionProps: {
      type: Object,
      default: () => ({
        label: 'label',
        value: 'value',
        disabled: 'disabled'
      })
    },
    max: {
      type: [String, Number]
    }
  },
  emits: ['update:value', 'change'],
  setup(props, context) {
    const handleChanged = ({
      checked,
      value,
      $event
    }) => {
      context.emit('change', {
        checked,
        value,
        $event
      });
      context.emit('update:value', value, $event);
    };
    return {
      handleChanged
    };
  }
};